// FURGAPI foi adicionado ao index.html junto com o jQuery.
// eslint-disable-next-line no-undef
export default FURGAPI;

const TOKEN_CHAMAMENTO = '@Chamamento';

export const getChamamentos = async () => {
    // eslint-disable-next-line
    const chamamento = await FURGAPI.call('sischamamentos/Publico/obtemProcessosSeletivos');
    sessionStorage.setItem(TOKEN_CHAMAMENTO, JSON.stringify(chamamento));
    return chamamento;
};

export const getChamamento = async id => {
    let chamamentos = JSON.parse(sessionStorage.getItem(TOKEN_CHAMAMENTO));
    if (null === chamamentos) {
        chamamentos = await getChamamentos();
    }
    let chamamento = [];
    chamamentos.every(processoSeletivo => {
        chamamento = processoSeletivo.chamamentos.filter(chamamento => Number(chamamento.id_calendario_prematricula) === Number(id));
        if (chamamento.length > 0) {
            chamamento = [{ ...chamamento[0], ds_processo_seletivo: processoSeletivo.ds_processo_seletivo }];
            return false;
        }
        return true;
    });
    return chamamento[0] || false;
};
